<template>
  <div
    class="c-navigation-panel -responsive"
    :class="{ 'is-visible': openedPanelIndex !== null }"
  >
    <div
      class="c-navigation-panel__content-container"
    >
      <div
        v-for="(category, index) in categoryTree"
        :key="`div-${index}`"
        class="c-navigation-panel__content"
        :class="{ 'is-visible': isVisible(index) }"
        @mouseleave="handleMouseEvent('leave')"
        @mouseenter="handleMouseEvent('enter')"
      >
        <div class="o-container t-full">
          <div class="o-grid -xs-left -xs-no-gutter t-full">
            <aside class="o-grid__item -xs-shrink">
              <div class="c-navigation-panel__featured">
                <a
                  v-for="(button, key) in columns[index].featured"
                  :key="`button-${key}`"
                  class="c-navigation-panel__button"
                  :href="`${button.path}&ref=${searchCategoriesRef}`"
                >

                  {{ button.title }}
                </a>
              </div>
            </aside>

            <div class="o-grid__item">
              <div class="o-grid -xs-left -xs-gutter-large t-full -xs-start">
                <div
                  v-for="(column, i) in columns[index].columns"
                  :key="`column-${i}`"
                  class="o-grid__item -xs-4"
                >
                  <nav
                    v-for="(blockOfLinks, j) in column"
                    :key="`block-of-lines-${j}`"
                    class="c-navigation-panel__block-of-links"
                  >
                    <a
                      v-for="(link, k) in blockOfLinks"
                      :key="`link-${k}`"
                      class="c-navigation-panel__link o-text -xs-long-primer"
                      :class="{
                        '-xs-bold': link.type == 'title',
                        '-extra': link.type == 'extra'
                      }"
                      :href="`${link.path}&ref=${searchCategoriesRef}`"
                    >
                      {{ link.title }}
                    </a>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { PRODUCTS_SEARCH_CONTEXT } from '@/tools/constants/contexts-for-metrics'

  import '@engines/stylesheets/ui/objects/_grid.scss'
  import '@engines/stylesheets/ui/objects/_container.scss'
  import '@engines/stylesheets/ui/objects/_text.scss'

  export default {
    props: {
      categoryTree: {
        type: Array,
        required: true
      },
      featured: {
        type: Array,
        default: () => []
      },
      columns: {
        type: Array,
        default: () => []
      },
      openedPanelIndex: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        searchCategoriesRef: PRODUCTS_SEARCH_CONTEXT.SEARCH_CATEGORIES_MENU
      }
    },
    methods: {
      handleMouseEvent(eventType) {
        this.$emit(`mouse-${eventType}-content`)
      },
      isVisible(index) {
        return index === this.openedPanelIndex
      }
    }
  }
</script>
